import React, { Fragment, useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {  Grid, TextField, CircularProgress, Avatar,
	  List, ListItem, ListSubheader, Divider } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import HeaderBar from './HeaderBar.js';
import { TrainerContext } from '../contexts/TrainerContext.js';
import MainNavigation from './MainNavigation.js';
import firebase from '../Firebase.js';

const useStyles = makeStyles(
  (theme) =>
    createStyles({
      container: {
	marginTop: theme.spacing(2),
	overflow: 'auto',
	'-webkit-overflow-scrolling': 'touch',
	[theme.breakpoints.up('sm')] : {
	  height: `calc(100% - 64px)`
	},
	[theme.breakpoints.down('xs')] : {
	  height: `calc(100% - 56px)`
	},
      },
      searchBox: {
	backgroundColor: theme.palette.background.paper,
      },
      avatar: {
	width: 70,
	height: 70,
      },
    }),
);


export default () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { admins, setState } = useContext(TrainerContext);
  const [searchText, setSearchText] = useState('');

  const filterAdmins = () => {
    const txt = searchText.toLowerCase();
    return admins.filter((item) => {
      return item.name.toLowerCase().includes(txt)
	|| item.email.toLowerCase().includes(txt)
	|| item.about.toLowerCase().includes(txt);
    });
  };

  useEffect(() => {
    const getAdmins = async () => {
      try {
	const rez = await firebase.firestore().collection('trainers')
	      .where('hasRoleAdmin', '==', true).get();

	const adminsProfilesProms = rez.docs.map((doc) => {
	  return firebase.firestore().collection('trainers')
	    .doc(doc.id).collection('profile')
	    .doc('details')
	    .get();
	});
	const adminsProfiles = await Promise.all(adminsProfilesProms);
	const admins = rez.docs.reduce((acc, doc, i) => {
	  return acc.concat([{ ...doc.data(), ...adminsProfiles[i].data(), email: doc.id}]);
	}, []);
	setState(s => {
	  return { ...s, admins};
	});
      }
      catch (errors) {
	console.log(errors);
	setState(s => {
	  return { ...s, admins: []};
	});
      }
    };
    if (admins === null) {
      getAdmins();
    }
  }, []);

  return (
    <div style={{height: '100%'}}>
      <HeaderBar LComp={<MainNavigation />}
		 MComp={<Typography variant='h6' noWrap align='center'>{t('admins')}</Typography>}
		 RComp={<div></div>}/>
      { admins === null
	? <Grid container justify='center' alignItems='center' className={classes.container}>
	    <CircularProgress color='secondary'/>
	  </Grid>
	: <Fragment>
	    <List disablePadding className={classes.container}>
	      <ListSubheader className={classes.searchBox}>
		<Grid container>
		  <TextField
		    fullWidth
		    type='search'
		    value={searchText}
		    placeholder={t('search-admin')}
		    onChange={(e) =>{
		      setSearchText(e.target.value.trim());
		    }}
		    margin='normal'/>
		</Grid>
	      </ListSubheader>
	      { filterAdmins().map((trainer) => {
		return (
		  <Fragment key={trainer.email}>
		    <ListItem onClick={() => {}}>
		      <Grid container alignItems='center'>
			<Grid item xs={3}>
			  <Avatar alt='avatar' src={trainer.avatar} className={classes.avatar}/>
			</Grid>
			<Grid item container xs={9} direction='column'>
			  <Typography gutterBottom variant='h6'>
			    {trainer.name}
			  </Typography>
			  <Typography gutterBottom variant='body1'>
			    {trainer.email}
			  </Typography>
			  <Typography gutterBottom variant='body2'>
			    {trainer.about}
			  </Typography>
			</Grid>
		      </Grid>
		    </ListItem>
		    <Divider />
		  </Fragment>
		);
	      })}
	    </List>
	  </Fragment>
      }
    </div>
  );
};
